import React, { useState } from 'react';
import { useAppDispatch } from '../../../../../shared/libs/redux';
import {
	notificationError, notificationSuccess, notificationWarning,
} from '../../../../../components/Notifications/callNotifcation';
import {
	workshopModuleTagGroupActions,
	workshopModuleTagGroupApi,
} from '../../../../../entities/module/tag-group/workshop-module-tag-group';

export const useGroupActions = (initialName: string, groupId: string) => {
	const dispatch = useAppDispatch();

	const [editableGroup, setEditableGroup] = useState<string | null>(null);
	const [newGroupName, setNewGroupName] = useState(initialName);

	const { data: existingGroups } = workshopModuleTagGroupApi.useGetWorkshopGroupsQuery({ limit: 127, page: 1 });
	const [updateGroup] = workshopModuleTagGroupApi.useUpdateMutation();

	const openDeleteGroupModal = () => {
		dispatch(workshopModuleTagGroupActions.setDeletingGroupId(groupId));
		dispatch(workshopModuleTagGroupActions.setIsDeleteGroupModalActive(true));
	};

	const updateGroupName = () => {
		try {
			if (newGroupName.trim().length < 2) {
				notificationError('Ошибка', 'Название группы должно содержать не менее 2-х символов');
				return;
			}

			if (newGroupName === initialName) {
				setEditableGroup(null);
				return;
			}

			const groupNames = existingGroups?.tagGroups.map((group) => group.name.toLowerCase()) ?? [];
			if (groupNames.includes(newGroupName.toLowerCase())) {
				notificationWarning(
					'Изменение названия группы',
					`Группа с именем "${newGroupName}" уже существует`,
				);
				return;
			}

			if (editableGroup !== null && newGroupName.trim() !== '') {
				updateGroup({ groupId: editableGroup, name: newGroupName });
				setEditableGroup(null);
				notificationSuccess('Название группы изменено успешно');
			}
		} catch (e) {
			notificationError('Произошла ошибка при обновлении имени группы...');
			console.log(e);
		}
	};

	const handleGroupNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNewGroupName(e.target.value);
	};

	return {
		handleGroupNameChange,
		openDeleteGroupModal,
		setEditableGroup,
		setNewGroupName,
		updateGroupName,
		editableGroup,
		newGroupName,
	};
};
